import type { AxiosError } from "axios";
import type { TFunction } from "i18next";
import type { FieldValues, Path, UseFormSetError } from "react-hook-form";

import type { ProblemDetails } from "@/lib/helpers/handleProblemDetailsError";

const MESSAGE_BY_CODE: Record<string, { field: "tokens" | "reason"; key: string }> = {
  "CaptainTokenAccount.TopUpNotPositive": { field: "tokens", key: "notPositive" },
  "CaptainTokenAccount.EmptyCorrection": { field: "tokens", key: "zero" },
  "CaptainTokenAccount.CorrectionWithoutReason": { field: "reason", key: "reasonRequired" },
};

const AMOUNT_FIELD = "tokens";

export function applyBillingError<TValues extends FieldValues>(
  error: AxiosError<ProblemDetails>,
  setError: UseFormSetError<TValues>,
  t: TFunction,
): string | undefined {
  const amountField = AMOUNT_FIELD as Path<TValues>;
  const problem = error.response?.data;
  const known = problem?.title ? MESSAGE_BY_CODE[problem.title] : undefined;
  if (known) {
    const field = known.field === "tokens" ? amountField : ("reason" as Path<TValues>);
    setError(field, { type: "server", message: t(`captainBilling.editors.errors.${known.key}`) });
    return undefined;
  }
  if (problem?.title === "Validation" && problem.detail) {
    setError(amountField, { type: "server", message: problem.detail });
    return undefined;
  }
  if (problem?.title === "CaptainTokenAccount.NotFound") return t("captainBilling.editors.errors.notFound");
  return t("errors.somethingWentWrong");
}
